export default __webpack_public_path__ + "static/media/loginBg.f704c879.png";